import React, { useState } from 'react';
import { Modal, Form, Input, Select, Checkbox, message } from 'antd';
import api from '../utils/api';

const AddTeamMemberModal = ({ hostels, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employeeType = Form.useWatch('employeeType', form);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const submitData = {
        name: values.name,
        email: values.email,
        password: values.password,
        employeeType: values.employeeType,
      };
      if (values.employeeType === 'accountant') {
        if (!values.hostelIds?.length) {
          message.error('Accountants must have at least one accessible hostel');
          return;
        }
        submitData.hostelIds = values.hostelIds;
      } else {
        if (!values.hostel) {
          message.error('Please select a hostel');
          return;
        }
        submitData.hostel = values.hostel;
      }
      setLoading(true);
      await api.post('/admin/team-members', submitData);
      message.success('Employee added');
      form.resetFields();
      onSuccess();
      onClose();
    } catch (err) {
      if (err.errorFields) return;
      message.error(err.response?.data?.message || 'Error adding employee');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Employee"
      open
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
      okText="Add"
      width={480}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ required: true }, { type: 'email' }]}>
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }, { min: 6, message: 'Min 6 characters' }]}>
          <Input.Password placeholder="Password" />
        </Form.Item>
        <Form.Item name="employeeType" label="Employee Type" rules={[{ required: true }]}>
          <Select
            placeholder="Select type"
            options={[
              { value: 'cleaner', label: 'Cleaner' },
              { value: 'cook', label: 'Cook' },
              { value: 'accountant', label: 'Accountant' },
              { value: 'guard', label: 'Guard' },
              { value: 'driver', label: 'Driver' },
            ]}
          />
        </Form.Item>
        {employeeType === 'accountant' && (
          <Form.Item name="hostelIds" label="Accessible Hostels" rules={[{ required: true, message: 'Select at least one hostel' }]}>
            <Checkbox.Group style={{ width: '100%', maxHeight: 200, overflow: 'auto', display: 'block' }}>
              {hostels.map((h) => (
                <div key={h._id}><Checkbox value={h._id}>{h.name}</Checkbox></div>
              ))}
            </Checkbox.Group>
          </Form.Item>
        )}
        {employeeType && employeeType !== 'accountant' && (
          <Form.Item name="hostel" label="Hostel" rules={[{ required: true }]}>
            <Select placeholder="Select hostel" options={hostels.map((h) => ({ value: h._id, label: h.name }))} />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default AddTeamMemberModal;
